import { FC } from "react"
import AppLayout from "../../components/layout/app-layout/app-layout";
import FileArea from "./FileArea";
import Card from "../../components/shared/Card/card";


type Props = {}

const PageFiles : FC<Props> = () => {
  return (
    <AppLayout title="Filer">
      <div style={{margin: "32px"}}>
        <Card>
          <FileArea root={"/files"} />
        </Card>
      </div>
    </AppLayout>
  );

}

export default PageFiles;